module.exports = __webpack_public_path__ + "media/images/malvinas/covid19_rules-eda1bf37373f928229e16735e8a1d4db.svg";